<template>
  <div class="info_content">
    <div class="info_contnet_list">
      <ul>
        <li>
          <span>姓名</span>
          <span>
              <input type="text" placeholder="请输入" @click="usernameClick" @blur.capture="handleBug" v-model="formInfodata.driverName" onkeyup="value=value.replace(/[\d]/g,'') " onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"/>
          </span>
        </li>
        <li class="checkformat" v-if="isEmptyDriverName">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>姓名不能为空</span>
        </li>
        <li :class="errorTips || ageTips ? 'errorBorder':''">
          <span>身份证号</span>
          <span>
              <input type="text"  
                placeholder="请输入"
                @blur.capture="handleBug"
                v-model="formInfodata.idCardNo" 
                oninput="if(value.length>18)value=value.slice(0,18)" 
                @click="idCardClick"  
                @blur="handleBlur" 
              />
          </span>
        </li>
        <li class="checkformat" v-if="errorTips">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>请输入正确的身份证号</span>
        </li>
        <li class="checkformat" v-if="ageTips">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>您的年龄未达到标准</span>
        </li>
        <li class="checkformat" v-if="isEmptyIdCard">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>身份证号不能为空</span>
        </li>
        <li @click="showCustomPicker('sex')">
          <span>性别</span>
          <span v-if="!formInfodata.sex">请选择<img src="@/assets/images/xuanze.png" /></span>
          <span v-else>{{ formInfodata.sex }}<img src="@/assets/images/xuanze.png" /></span>
        </li>
        <li class="checkformat" v-if="isEmptySex">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>性别不能为空</span>
        </li>
        <li @click="showDate('idCardExpiryDate')" :class="expiryDateTips ?'errorBorder':''">
          <span>有效截止日期</span>
          <span v-if="!formInfodata.idCardExpiryDate">请选择<img src="@/assets/images/xuanze.png" /></span>
          <span v-else>{{ formInfodata.idCardExpiryDate }}<img src="@/assets/images/xuanze.png" /></span>
        </li>
        <li class="checkformat" v-if="expiryDateTips">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>证件已失效无法注册</span>
        </li>
        <li class="checkformat" v-if="isEmptyIED">
          <span></span><span style="color:#e30000"><img  src="@/assets/images/errorTips.png"/>身份证有效截止日期不能为空</span>
        </li>
      </ul>
    </div>
    <!-- <div :class="!isTrigger?'info_content_dis_btn' : 'info_content_dis_btn info_content_btn'" @click="nextStep">下一步</div> -->
    <van-popup v-model="showPicker" position="bottom">
       <customPicker :columns='columns' @confirmPicker="confirmPicker" @cancelPicker='cancelPicker'></customPicker>
    </van-popup>
    <van-popup v-model="showDatePicker" position="bottom">
       <DateTimePicker v-if="showDatePicker" :showDatePicker='showDatePicker' :minDate='minDate' :maxDate='maxDate' @confirm="onConfirmDate" @cancel='onCancel' :currentDate='currentDate'></DateTimePicker>
    </van-popup>
  </div>
</template>

<script>
import customPicker from '@/components/customPicker'
import DateTimePicker from '@/components/dateTimePicker'
import { handleBuryPoint } from "@/utils/tool.js";
export default {
  data() {
    return {
      subSource: '',
      columns: [],
      showPicker: false,
      errorTips: false,
      ageTips: false,
      isGray: false,
      tenantId:'',
      pickerCode:'',
      sexCode:0,
      formDataInfo: {},
      newCity:'',
      formContent:false,
      showDatePicker: false,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      expiryDateTips: false
    };
  },
  props: {
    formInfodata: {
      type: Object,
      default: () => {}
    },
    entryRuleState: {
      type: Number,
      default: 0
    },
    showCardInfoTips: {
      type: Boolean,
      default: false
    },
    ageRule:{
      type: Object,
      default: () => {}
    },
    isEmptyDriverName: {
      type: Boolean,
      default: false
    },
    isEmptyIdCard: {
      type: Boolean,
      default: false
    },
    isEmptySex: {
      type: Boolean,
      default:false
    },
    isEmptyIED: {
      type:Boolean,
      default:false
    }
  },
  components:{
    customPicker,
    DateTimePicker
  },
  watch:{
    showCardInfoTips(n,o){ //n为新值,o为旧值;
      console.log(n, 'pippopip')
      this.errorTips = n
      this.ageTips = n
    }
  },
  mounted(){
  },
  computed: {
    getCurrentDay() {
      var date = new Date(); 
      var year = date.getFullYear()
      var month = date.getMonth() + 1;
      var day = date.getDate();
      month = (month > 9) ? month : ("0" + month);
      day = (day < 10) ? ("0" + day) : day;
      return year + "-" + month + "-" + day;
    },
    // 计算年龄
    getAge() {
      return function (iden){
        let val = iden.length;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        let age = 0;
        if (val === 18) {
          age = myDate.getFullYear() - iden.substring(6, 10) - 1;
          if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;
        }
        if (val === 15) {
          age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
          if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
        }
        return age
      }
    },
  },
  methods: {
    onConfirmDate({data, value, showDatePicker}) {
      console.log(this.getCurrentDay>value)
      this.expiryDateTips = value < this.getCurrentDay ? true : false
      this.formInfodata.idCardExpiryDate = value;
      this.showDatePicker = showDatePicker
      this.$emit('receveDateStatus', {expiryDateTips:this.expiryDateTips, isEmptyIED:false})
    },
    onCancel({showDatePicker}){
      this.$forceUpdate()
      this.showDatePicker = showDatePicker
    },
    showDate (val) {
      if(val == 'idCardExpiryDate') {
        this.minDate = new Date(1960, 0, 1)
        this.maxDate = new Date(2050, 11, 1)
        this.currentDate = new Date()
      }else{
        this.minDate = new Date(2000, 0, 1)
        this.maxDate = new Date(2100, 11, 1)
        this.currentDate = new Date()
      }
      this.code = val
      this.showDatePicker = true;
    },
    // 点击姓名埋点
    usernameClick() {
      handleBuryPoint('recruiting-Information', 'nameInputBox_Click', {})
    },
    // 点击身份证号埋点
    idCardClick() {
      handleBuryPoint('recruiting-Information', 'idCardNumberInputBox_Click', {})
    },
    // 兼容ios键盘弹起界面不恢复原状态
    handleBug() {
      let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      if (this.formInfodata.driverName) {
        this.$emit("handleHideNameTips", false)
      }
      window.scrollTo(0, Math.max(scrollHeight - 1, 0))
    },
    // 身份证失焦的时候进行正则验证
    handleBlur(){
      // 中国台湾
      const idNumberReg = /^(\d{6}(18|19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$)|(^\d{8}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3})$/
      if(!idNumberReg.test(this.formInfodata.idCardNo)){
        this.errorTips = true
        this.ageTips = false
        this.isEmptyIdCard = false
      } else {
        this.errorTips = false
        this.isEmptyIdCard = false
        if (this.entryRuleState == 1) {
          if (this.getAge(this.formInfodata.idCardNo) < this.ageRule.minAge || this.getAge(this.formInfodata.idCardNo) > this.ageRule.maxAge) {
            this.ageTips = true
          } else {
            this.ageTips = false
            if (this.formInfodata.idCardNo) {
              this.isEmptyIdCard = false
            }
          }
        }
      }
      this.$emit('receveErrorStatus', {errorTips:this.errorTips,ageTips: this.ageTips, isEmptyIdCard: this.isEmptyIdCard})
    },
    // 点击对应的picker项
    showCustomPicker(val) {
      this.pickerCode = val
      if(this.pickerCode == 'sex'){
          this.columns=['男', '女']
      }
      this.showPicker = true;
    },
    // 确认选择的picker值
    confirmPicker({data,value,showPicker}) {
      if(this.pickerCode == 'sex'){
           this.formInfodata.sex = value
           if(this.formInfodata.sex=='男'){
             this.sexCode = 1
             handleBuryPoint('recruiting-Information', 'genderOptions_Click', {genderOptions_Click:1})
           }else{
             this.sexCode = 2
             handleBuryPoint('recruiting-Information', 'genderOptions_Click', {genderOptions_Click:2})
           }
           this.$emit("handleHideSexTips", false)
       }else if(this.pickerCode == 'LicenseClass'){
           handleBuryPoint('recruiting-Information', 'driverLicenseType_Click', {})
           this.formInfodata.driverLicenseClass = value
       }
       this.showPicker = showPicker
    },
    cancelPicker({showPicker}){
        this.showPicker =showPicker
    },
    showCard() {
      this.showCardPicker = true;
    },
    onConfirm(value) {
      this.formInfodata.sex = value;
      this.showPicker = false;
    }
  }
};
</script>

<style lang='less' scoped>
/deep/ .van-picker__toolbar {
  height: 80px;
}
/deep/ .van-picker-column {
  font-size: 30px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 30px;
}
/deep/ .van-picker__title{
    font-size: 25px;
    line-height: 35px;
}
.info_content_mask{
  width: 718px;
  height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index:10000
}
.info_content {
  background: #f5f5f5;
  // margin-bottom: 60px;
  .info_contnet_list {
    background: #ffffff;
    // position: relative;
    // z-index: 100;
    // margin-bottom: 61px;
    ul {
      li:first-child{
        p:nth-of-type(2){
          span:first-child{
            color: #176AF0;
          }
        }
        img{
          width: 40px;
          height: 20px;
        }
      }
      li {
        display: flex;
        justify-content: space-between;
        padding: 0px 24px;
        font-size: 32px;
        color: #333333;
        height: 112px;
        line-height: 112px;
        border-bottom: 1px solid #e0e0e0;
        input {
          background: none;
          outline: none;
          display: flex;
          flex: 1;
          width: 370px;
          // height: 70px;
          border: none;
          text-align: right;
        }
        input::-webkit-input-placeholder { 
        /* WebKit browsers */ 
        color: #176AF0; 
        } 
        span {
          img {
            width: 20px;
            height: 40px;
            margin-left: 20px;
            vertical-align: middle;
          }
        }
        span:nth-of-type(2){
          color: #176AF0;
        }
      }
    }
    .errorBorder{
        border-bottom:1px solid #E30000; ;
    }
    .checkformat{
        font-size: 24px;
        color:#e30000;
        line-height: 50px;
        height: 50px;
        border-bottom: none;
        img{
            position: relative;
            bottom:2px;
            margin-right: 10px;
            width: 28px;
            height: 28px;
        }
    }
  }
}
</style>